import { Box, Grid, Container } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { useGutterSpacing } from '@/hooks/use-gutter-spacing';
import FeatureTile from '@/components/feature-tile';
import { H3, SectionHeading } from '@/components/type';

import { HeadingWrapper } from './styles';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'heading' implicitly has an 'any' type.
const FeatureTilesListing = ({ featureTiles = [], heading, subHeading }) => (
  <Container maxWidth="xl">
    <Box my={{ xs: 9, sm: 18 }}>
      <HeadingWrapper>
        <H3 as="h2">{heading}</H3>
        <Box mb={{ xs: 6, sm: 9 }} mt={{ xs: 1.5, sm: 3 }}>
          <SectionHeading>{subHeading}</SectionHeading>
        </Box>
      </HeadingWrapper>

      <Grid container spacing={useGutterSpacing()}>
        {_.map(featureTiles, (featureTile) => {
          return (
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'heading' does not exist on type 'never'.
            <Grid key={featureTile.heading} {...{ item: true, md: 6, xs: 12 }}>
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Spread types may only be created from object types. */}
              <FeatureTile {...featureTile} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  </Container>
);

FeatureTilesListing.propTypes = {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 1 arguments, but got 0.
  featureTiles: PropTypes.arrayOf(PropTypes.shape()),
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
};

export default FeatureTilesListing;
